import controller from './tableGridBody.controller';

let tableGridBodyComponent = () => {
  return {
    restrict: 'A',
    scope: {
      columns: '=',
      options : '=',
      metaData : '=',
      data: '=',
      getNextSetOfRowsToFetch : '&',
      toggleSort : '&',
      sortBy: '=',
      rowOptions: '=',
      searchValue: '=',
      fetchResults: '&',
      rowsSelected: '=',
      isAllRowsSelected: '='
    },
    controller,
    controllerAs: 'vm',
    link: (scope) => {
      scope.vm = scope;
    }
  };
};

export default tableGridBodyComponent;



// WEBPACK FOOTER //
// ./app/components/tableGridBody/tableGridBody.component.js